import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

const PuzzleExcludeStateFilter = ({ excludeDiscarded, excludeDisabled, onExcludeDiscardedChange, onExcludeDisabledChange }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                Exclude (when All States selected)
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={excludeDiscarded}
                            onChange={onExcludeDiscardedChange}
                        />
                    }
                    label="Discarded"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={excludeDisabled}
                            onChange={onExcludeDisabledChange}
                        />
                    }
                    label="Disabled"
                />
            </Box>
        </Box>
    );
};

export default PuzzleExcludeStateFilter;
